import React, { useState } from 'react';
import '../../styles/task.css'; // Import the CSS file
import { FaEdit, FaTrashAlt } from 'react-icons/fa'; // Importing icons

export default function TaskManagementTable() {
  const [searchTerm, setSearchTerm] = useState('');
  const [filter, setFilter] = useState('');

  const tasks = [
    { name: 'Respiratory Therapist', status: 'Hired', date: '2024-10-01', statusClass: 'green' },
    { name: 'Lab Technician', status: 'In Progress', date: '2024-09-28', statusClass: 'blue' },
    { name: 'Physical Therapist', status: 'Pending', date: '2024-09-29', statusClass: 'red' },
    { name: 'Radiologic Assistant', status: 'Progress', date: '2024-09-29', statusClass: 'blue' },
    { name: 'Anesthesiologist', status: 'Hired', date: '2024-09-29', statusClass: 'green' },
    { name: 'Oral Surgeon', status: 'Hired', date: '2024-09-29', statusClass: 'green' },
    { name: 'Pediatrician', status: 'Pending', date: '2024-09-29', statusClass: 'red' },
  ];

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleFilter = (event) => {
    setFilter(event.target.value);
  };

  const filteredTasks = tasks
    .filter(task => 
      task.name.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (filter === '' || task.status === filter)
    );

  return (
    <div className="task-container">
      <div className="task-controls">
        <input 
          type="text" 
          placeholder="Search by task name" 
          value={searchTerm} 
          onChange={handleSearch}
          className="task-search-bar"
        />
        <select onChange={handleFilter} className="task-filter-dropdown">
          <option value="">All</option>
          <option value="Completed">Completed</option>
          <option value="In Progress">In Progress</option>
          <option value="Pending">Pending</option>
        </select>
      </div>

      <div className="task-table-container">
        <table className="task-table">
          <thead>
            <tr>
              <th>Task Name</th>
              <th>Status</th>
              <th>Posted Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredTasks.length > 0 ? (
              filteredTasks.map((task, index) => (
                <tr key={index}>
                  <td>{task.name}</td>
                  <td>
                    <span className={`task-status-dot ${task.statusClass}`}></span>
                    <span className="task-status-text">{task.status}</span>
                  </td>
                  <td>{task.date}</td>
                  <td>
                    <FaEdit className="task-icon-edit" />
                    <FaTrashAlt className="task-icon-delete" />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4">No tasks found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}